import * as React from "react";
import type { SVGProps } from "react";
const SvgFilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="filter_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M46.635 110.08a42.667 42.667 0 0 1 38.698-24.747h853.334a42.667 42.667 0 0 1 32.597 70.23L640 547.243V896a42.667 42.667 0 0 1-61.739 38.144l-170.666-85.333A42.667 42.667 0 0 1 384 810.667V547.243L52.736 155.563a42.667 42.667 0 0 1-6.101-45.526zm130.645 60.587 281.984 333.397a42.667 42.667 0 0 1 10.07 27.563v252.672l85.333 42.666V531.627a42.667 42.667 0 0 1 10.069-27.563L846.72 170.667H177.28z"
    />
  </svg>
);
export default SvgFilterIcon;
